<div class="challenges-home">
  <app-header></app-header>

  <div class="challenges-home--content">
    <!-- Header Section -->
    <app-asset-header [config]="headerConfig"></app-asset-header>

    <!-- Main Content -->
    <div class="challenges-home--main">
      <div class="challenges-home--container">
        <!-- Manage Challenges Sidebar -->
        <aside class="challenges-home--sidebar">
          <app-manage-challenges-sidebar [activeTab]="activeTab"></app-manage-challenges-sidebar>
        </aside>

        <!-- Main Grid Section -->
        <main class="challenges-home--grid">
          <!-- Overview Section -->
          <div class="challenges-overview" *ngIf="activeTab === 'overview'">
            <!-- Empty state when no challenges in any category -->
            <div class="challenges-overview--empty-state" *ngIf="newChallenges.length === 0 && underEvaluation.length === 0 && pastChallenges.length === 0">
              <div class="challenges-overview--empty-state-icon" aria-hidden="true">
                <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6M18 9h1.5a2.5 2.5 0 0 0 0-5H18"/>
                  <path d="M6 5v4M18 5v4"/>
                  <path d="M4 22h16"/>
                  <path d="M10 14.66V17c0 .55-.47 1-1.05 1H7.05C6.47 18 6 17.55 6 17v-2.34"/>
                  <path d="M14 14.66V17c0 .55.47 1 1.05 1h1.9c.58 0 1.05-.45 1.05-1v-2.34"/>
                  <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"/>
                </svg>
              </div>
              <h2 class="challenges-overview--empty-state-title">Watch out for this space for new challenges.</h2>
              <p class="challenges-overview--empty-state-description">
                Watch this space for upcoming challenges designed to spark the next wave of healthcare innovation.
              </p>
            </div>

            <!-- New Challenges (hide when data.competitions is empty) -->
            <div class="challenges-overview--section" *ngIf="newChallenges.length > 0">
              <div class="challenges-overview--section-header">
                <div class="challenges-overview--title-section">
                  <h2 class="challenges-overview--section-title">New Challenges</h2>
                  <p class="challenges-overview--section-description">
                    Discover the newest challenges available. These are the latest competitions that have been recently added to the platform.
                  </p>
                </div>
                <a 
                  class="challenges-overview--view-all-link"
                  (click)="navigateToTab('new-challenges'); $event.preventDefault()"
                  href="/challenges?tab=new-challenges"
                >
                  View New Challenges
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </a>
              </div>
              <div class="challenges-overview--carousel-wrapper">
                <app-carousel 
                  [items]="newChallenges" 
                  [itemsToShow]="carouselItemsToShow"
                  [showDots]="true"
                  [showArrows]="true"
                  [gap]="24"
                  (slideChange)="onNewChallengesSlideChange($event)"
                >
                  <div 
                    *ngFor="let challenge of newChallenges; let i = index" 
                    class="carousel-item"
                  >
                    <app-challenge-card
                      [data]="challenge"
                      [showDescription]="false"
                    ></app-challenge-card>
                  </div>
                </app-carousel>
              </div>
            </div>

            <!-- Under Evaluation (hide when data.competitions is empty) -->
            <div class="challenges-overview--section" *ngIf="underEvaluation.length > 0">
              <div class="challenges-overview--section-header">
                <div class="challenges-overview--title-section">
                  <h2 class="challenges-overview--section-title">Under Evaluation</h2>
                  <p class="challenges-overview--section-description">
                    Track your submitted challenges that are currently being evaluated. These are challenges you've participated in and are waiting for results.
                  </p>
                </div>
                <a 
                  class="challenges-overview--view-all-link"
                  (click)="navigateToTab('ongoing-challenges'); $event.preventDefault()"
                  href="/challenges?tab=ongoing-challenges"
                >
                  View Under Evaluation
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </a>
              </div>
              <div class="challenges-overview--carousel-wrapper">
                <app-carousel 
                  [items]="underEvaluation" 
                  [itemsToShow]="carouselItemsToShow"
                  [showDots]="true"
                  [showArrows]="true"
                  [gap]="24"
                  (slideChange)="onUnderEvaluationSlideChange($event)"
                >
                  <div 
                    *ngFor="let challenge of underEvaluation; let i = index" 
                    class="carousel-item"
                  >
                    <app-challenge-card
                      [data]="challenge"
                      [showDescription]="false"
                    ></app-challenge-card>
                  </div>
                </app-carousel>
              </div>
            </div>

            <!-- Past Challenges (hide when data.competitions is empty) -->
            <div class="challenges-overview--section" *ngIf="pastChallenges.length > 0">
              <div class="challenges-overview--section-header">
                <div class="challenges-overview--title-section">
                  <h2 class="challenges-overview--section-title">Past Challenges</h2>
                  <p class="challenges-overview--section-description">
                    Review completed challenges where results have been announced. Explore past competitions and their outcomes.
                  </p>
                </div>
                <a 
                  class="challenges-overview--view-all-link"
                  (click)="navigateToTab('past-challenges'); $event.preventDefault()"
                  href="/challenges?tab=past-challenges"
                >
                  View Past Challenges
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </a>
              </div>
              <div class="challenges-overview--carousel-wrapper">
                <app-carousel 
                  [items]="pastChallenges" 
                  [itemsToShow]="carouselItemsToShow"
                  [showDots]="true"
                  [showArrows]="true"
                  [gap]="24"
                  (slideChange)="onPastChallengesSlideChange($event)"
                >
                  <div 
                    *ngFor="let challenge of pastChallenges; let i = index" 
                    class="carousel-item"
                  >
                    <app-challenge-card
                      [data]="challenge"
                      [showDescription]="false"
                    ></app-challenge-card>
                  </div>
                </app-carousel>
              </div>
            </div>
          </div>

          <!-- New Challenges tab: search, grid/list/table, show 6, pagination (dataset collection style) -->
          <div class="challenges-new-tab" *ngIf="activeTab === 'new-challenges'">
            <div class="challenges-new-tab--header">
              <div class="challenges-overview--title-section">
                <h2 class="challenges-overview--section-title">New Challenges</h2>
                <p class="challenges-overview--section-description">
                  Discover the newest challenges available. These are the latest competitions that have been recently added to the platform.
                </p>
              </div>
            </div>

            <!-- Controls: always visible so search input keeps focus while typing (loading state shown in content area only) -->
            <div class="challenges-new-tab--controls">
              <div class="challenges-new-tab--search-wrapper">
                <div class="challenges-new-tab--search">
                  <input
                    type="text"
                    class="challenges-new-tab--search-input"
                    placeholder="Search for challenges"
                    [(ngModel)]="newChallengesTabSearchQuery"
                    (ngModelChange)="onNewChallengesTabSearchInput()"
                  />
                  <img src="/filters/search-normal.svg" alt="Search" class="challenges-new-tab--search-icon" />
                  <button
                    type="button"
                    class="challenges-new-tab--search-clear"
                    *ngIf="newChallengesTabSearchQuery?.length"
                    (click)="clearNewChallengesSearch()"
                    aria-label="Clear search"
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <line x1="18" y1="6" x2="6" y2="18"></line>
                      <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                  </button>
                </div>
              </div>
              <div class="challenges-new-tab--action-buttons">
                <div class="challenges-new-tab--sort-dropdown" (click)="$event.stopPropagation()">
                  <button
                    type="button"
                    class="challenges-new-tab--sort-trigger"
                    [class.open]="newChallengesTabSortDropdownOpen"
                    (click)="toggleNewChallengesTabSortDropdown()"
                    aria-label="Sort"
                  >
                    <span class="challenges-new-tab--sort-label">Sort: <span class="challenges-new-tab--sort-value">{{ getNewChallengesTabSelectedSortLabel() }}</span></span>
                    <span class="challenges-new-tab--sort-icon" [class.open]="newChallengesTabSortDropdownOpen">⇅</span>
                  </button>
                  <div class="challenges-new-tab--dropdown-panel challenges-new-tab--sort-panel" *ngIf="newChallengesTabSortDropdownOpen">
                    <button
                      *ngFor="let opt of newChallengesTabSortOptions"
                      type="button"
                      class="challenges-new-tab--dropdown-option"
                      [class.selected]="newChallengesTabSortOption === opt.value"
                      (click)="onNewChallengesTabSortOptionSelect(opt.value)"
                    >
                      <div class="checkbox-checkmark-custom" [class.checked]="newChallengesTabSortOption === opt.value"></div>
                      <span>{{ opt.label }}</span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="challenges-new-tab--controls-right">
                <div class="challenges-new-tab--show-dropdown" (click)="$event.stopPropagation()">
                  <button
                    type="button"
                    class="challenges-new-tab--dropdown-trigger"
                    [class.open]="newChallengesTabShowDropdownOpen"
                    (click)="toggleNewChallengesTabShowDropdown()"
                  >
                    <span>Showing: <span class="challenges-new-tab--dropdown-value">{{ newChallengesTabItemsPerPage }}</span></span>
                  </button>
                  <div class="challenges-new-tab--dropdown-panel" *ngIf="newChallengesTabShowDropdownOpen">
                    <button
                      *ngFor="let opt of newChallengesTabItemsPerPageOptions"
                      type="button"
                      class="challenges-new-tab--dropdown-option"
                      [class.selected]="newChallengesTabItemsPerPage === opt"
                      (click)="onNewChallengesTabItemsPerPageChange(opt)"
                    >
                      {{ opt }} results/page
                    </button>
                  </div>
                </div>
                <div class="challenges-new-tab--view-toggle">
                  <button
                    type="button"
                    class="challenges-new-tab--view-btn"
                    [class.active]="newChallengesTabViewMode === 'grid'"
                    (click)="onNewChallengesTabViewModeChange('grid')"
                    aria-label="Grid view"
                  >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <rect x="3" y="3" width="7" height="7" stroke="currentColor" stroke-width="2"/>
                      <rect x="14" y="3" width="7" height="7" stroke="currentColor" stroke-width="2"/>
                      <rect x="3" y="14" width="7" height="7" stroke="currentColor" stroke-width="2"/>
                      <rect x="14" y="14" width="7" height="7" stroke="currentColor" stroke-width="2"/>
                    </svg>
                    <span class="challenges-new-tab--view-label">Grid</span>
                  </button>
                  <button
                    type="button"
                    class="challenges-new-tab--view-btn"
                    [class.active]="newChallengesTabViewMode === 'list'"
                    (click)="onNewChallengesTabViewModeChange('list')"
                    aria-label="List view"
                  >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M8 6H21M8 12H21M8 18H21M3 6H3.01M3 12H3.01M3 18H3.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span class="challenges-new-tab--view-label">List</span>
                  </button>
                  <button
                    type="button"
                    class="challenges-new-tab--view-btn"
                    [class.active]="newChallengesTabViewMode === 'table'"
                    (click)="onNewChallengesTabViewModeChange('table')"
                    aria-label="Table view"
                  >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M3 3H21V21H3V3Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M3 9H21M9 3V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span class="challenges-new-tab--view-label">Table</span>
                  </button>
                </div>
              </div>
            </div>

            <div class="challenges-new-tab--loading" *ngIf="newChallengesTabLoading">
              <p>Loading new challenges…</p>
            </div>
            <div class="challenges-new-tab--empty" *ngIf="!newChallengesTabLoading && newChallengesTabData.length === 0">
              <p>No new challenges at the moment.</p>
            </div>
            <div class="challenges-new-tab--empty" *ngIf="!newChallengesTabLoading && newChallengesTabData.length > 0 && newChallengesTabFilteredData.length === 0">
              <p>No challenges match your search.</p>
            </div>

            <!-- Grid view -->
            <div class="challenges-new-tab--grid" *ngIf="!newChallengesTabLoading && newChallengesTabFilteredData.length > 0 && newChallengesTabViewMode === 'grid'">
              <app-challenge-card
                *ngFor="let challenge of newChallengesTabFilteredData"
                [data]="challenge"
                [showDescription]="false"
                class="challenges-new-tab--card"
              ></app-challenge-card>
            </div>
            <!-- List view: image left; Title, Subtitle, Date range + time left; stats row same as card (participants, submissions, prize with icons + arrow) -->
            <div class="challenges-new-tab--list" *ngIf="!newChallengesTabLoading && newChallengesTabFilteredData.length > 0 && newChallengesTabViewMode === 'list'">
              <a
                *ngFor="let c of newChallengesTabFilteredData"
                [routerLink]="['/challenges', c.id]"
                class="challenges-new-tab--list-item"
              >
                <div class="challenges-new-tab--list-image">
                  <img
                    [src]="c.imageUrl || defaultChallengeImageUrl"
                    [alt]="c.name"
                    [style.object-fit]="getListImageObjectFit(c)"
                    (load)="onListImageLoad(c, $event)"
                  />
                </div>
                <div class="challenges-new-tab--list-body">
                  <h3 class="challenges-new-tab--list-title">{{ c.name }}</h3>
                  <p class="challenges-new-tab--list-subtitle" *ngIf="c.provider">{{ c.provider }}</p>
                  <div class="challenges-new-tab--list-dates-row">
                    <span class="challenges-new-tab--list-dates" *ngIf="c.submissionStartsAt || c.submissionEndsAt">
                      <svg class="challenges-new-tab--list-dates-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                        <line x1="16" y1="2" x2="16" y2="6"></line>
                        <line x1="8" y1="2" x2="8" y2="6"></line>
                        <line x1="3" y1="10" x2="21" y2="10"></line>
                      </svg>
                      {{ formatChallengeSubmissionRange(c) }}
                    </span>
                    <span class="challenges-new-tab--list-time-left">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <circle cx="12" cy="12" r="10"></circle>
                        <polyline points="12 6 12 12 16 14"></polyline>
                      </svg>
                      {{ getListTimeLeftLabel(c) }}
                    </span>
                  </div>
                  <div class="challenges-new-tab--list-stats">
                    <div class="challenges-new-tab--list-stat" title="Participants">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                        <circle cx="9" cy="7" r="4"></circle>
                        <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                        <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                      </svg>
                      <span>{{ c.participants ?? 0 }}</span>
                    </div>
                    <div class="challenges-new-tab--list-stat" title="Submissions">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                        <polyline points="14 2 14 8 20 8"></polyline>
                        <line x1="16" y1="13" x2="8" y2="13"></line>
                        <line x1="16" y1="17" x2="8" y2="17"></line>
                        <polyline points="10 9 9 9 8 9"></polyline>
                      </svg>
                      <span>{{ c.submissions ?? 0 }}</span>
                    </div>
                    <div class="challenges-new-tab--list-stat" title="Prize">
                      <svg *ngIf="c.currency?.toUpperCase() === 'USD'" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <line x1="12" y1="1" x2="12" y2="23"></line>
                        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                      </svg>
                      <span class="challenges-new-tab--list-prize">{{ formatChallengePrize(c) }}</span>
                    </div>
                    <span class="challenges-new-tab--list-arrow">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M5 12h14M12 5l7 7-7 7"/>
                      </svg>
                    </span>
                  </div>
                </div>
              </a>
            </div>
            <!-- Table view -->
            <div class="challenges-new-tab--table-wrapper" *ngIf="!newChallengesTabLoading && newChallengesTabFilteredData.length > 0 && newChallengesTabViewMode === 'table'">
              <div class="challenges-new-tab--table-container">
                <table class="challenges-new-tab--table">
                  <thead>
                    <tr>
                      <th>TITLE</th>
                      <th>DESCRIPTION</th>
                      <th>SUBMISSION</th>
                      <th>PRIZE</th>
                      <th>PARTICIPANTS</th>
                      <th>ACTION</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let c of newChallengesTabFilteredData">
                      <td><div class="challenges-new-tab--table-title">{{ c.name }}</div></td>
                      <td>{{ c.description || c.provider || '—' }}</td>
                      <td>{{ formatChallengeSubmissionRange(c) }}</td>
                      <td>{{ formatChallengePrize(c) }}</td>
                      <td>{{ c.participants ?? 0 }}</td>
                      <td>
                        <button type="button" class="challenges-new-tab--table-action" aria-label="View details" (click)="navigateToDetail(c.id)">
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                            <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- Pagination (dataset collection design: First, Prev, numbers, Next, Last) -->
            <div class="challenges-new-tab--pagination" *ngIf="!newChallengesTabLoading && newChallengesTabData.length > 0 && newChallengesTabTotalPages > 1">
              <button
                type="button"
                class="challenges-new-tab--pagination-btn"
                [disabled]="newChallengesTabCurrentPage === 1"
                (click)="onNewChallengesTabPageChange(1)"
                aria-label="First page"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M11 18L5 12L11 6M18 18L12 12L18 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
              <button
                type="button"
                class="challenges-new-tab--pagination-btn"
                [disabled]="newChallengesTabCurrentPage === 1"
                (click)="onNewChallengesTabPageChange(newChallengesTabCurrentPage - 1)"
                aria-label="Previous page"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
              <div class="challenges-new-tab--pagination-numbers">
                <button
                  *ngFor="let page of getNewChallengesTabPageNumbers()"
                  type="button"
                  class="challenges-new-tab--pagination-number"
                  [class.active]="page === newChallengesTabCurrentPage"
                  (click)="onNewChallengesTabPageChange(page)"
                >
                  {{ page }}
                </button>
              </div>
              <button
                type="button"
                class="challenges-new-tab--pagination-btn"
                [disabled]="newChallengesTabCurrentPage === newChallengesTabTotalPages"
                (click)="onNewChallengesTabPageChange(newChallengesTabCurrentPage + 1)"
                aria-label="Next page"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
              <button
                type="button"
                class="challenges-new-tab--pagination-btn"
                [disabled]="newChallengesTabCurrentPage === newChallengesTabTotalPages"
                (click)="onNewChallengesTabPageChange(newChallengesTabTotalPages)"
                aria-label="Last page"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M13 18L19 12L13 6M6 18L12 12L6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
          </div>

          <!-- Regular View (All, Your Competitions, Past, Bookmarks) -->
          <div *ngIf="activeTab !== 'overview' && activeTab !== 'new-challenges'">
            <!-- Active Section Label -->
            <div class="challenges-section-label" *ngIf="activeLabel">
              <h2>{{ activeLabel }}</h2>
            </div>

            <!-- Bookmarks / Under Evaluation / Past Challenges loading -->
            <p *ngIf="(activeTab === 'bookmarked' && bookmarksLoading) || (activeTab === 'ongoing-challenges' && underEvaluationLoading) || (activeTab === 'past-challenges' && pastChallengesLoading)" class="challenges-section-loading">
              {{ activeTab === 'bookmarked' ? 'Loading bookmarks…' : activeTab === 'ongoing-challenges' ? 'Loading under evaluation…' : 'Loading past challenges…' }}
            </p>

            <!-- Challenges Submitted: 4 sub-tabs + table view -->
            <div *ngIf="activeTab === 'your-competitions'" class="challenges-submitted">
              <p *ngIf="submittedLoading" class="challenges-section-loading">Loading…</p>
              <div class="challenges-submitted--tabs" *ngIf="!submittedLoading">
                <button
                  type="button"
                  class="challenges-submitted--tab"
                  [class.active]="submittedSubTab === 'interested'"
                  (click)="setSubmittedSubTab('interested')"
                >
                  Interested
                </button>
                <button
                  type="button"
                  class="challenges-submitted--tab"
                  [class.active]="submittedSubTab === 'submitted'"
                  (click)="setSubmittedSubTab('submitted')"
                >
                  Submitted
                </button>
                <button
                  type="button"
                  class="challenges-submitted--tab"
                  [class.active]="submittedSubTab === 'in-evaluation'"
                  (click)="setSubmittedSubTab('in-evaluation')"
                >
                  In Evaluation
                </button>
                <button
                  type="button"
                  class="challenges-submitted--tab"
                  [class.active]="submittedSubTab === 'completed'"
                  (click)="setSubmittedSubTab('completed')"
                >
                  Completed
                </button>
              </div>

              <!-- Interested table -->
              <div class="challenges-new-tab--table-wrapper" *ngIf="!submittedLoading && submittedSubTab === 'interested'">
                <div class="challenges-new-tab--table-container">
                  <table class="challenges-new-tab--table">
                    <thead>
                      <tr>
                        <th>Challenge Name</th>
                        <th>Total Prize</th>
                        <th>Submission Start Date</th>
                        <th>Submission End Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let row of interestedRows">
                        <td><a [routerLink]="['/challenges', row.challengeId]" class="challenges-submitted--link">{{ row.challengeName }}</a></td>
                        <td>{{ row.totalPrize }}</td>
                        <td>{{ row.submissionStartDate }}</td>
                        <td>{{ row.submissionEndDate }}</td>
                      </tr>
                      <tr *ngIf="interestedRows.length === 0">
                        <td colspan="4" class="challenges-submitted--empty">No interested challenges.</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- Submitted table: Action dropdown = Solution download, Resubmission -->
              <div class="challenges-new-tab--table-wrapper" *ngIf="!submittedLoading && submittedSubTab === 'submitted'">
                <div class="challenges-new-tab--table-container">
                  <table class="challenges-new-tab--table">
                    <thead>
                      <tr>
                        <th>Challenge Name</th>
                        <th>Solution Name</th>
                        <th>Submission Start Date</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let row of submittedRows">
                        <td><a [routerLink]="['/challenges', row.challengeId]" class="challenges-submitted--link">{{ row.challengeName }}</a></td>
                        <td>{{ row.solutionName }}</td>
                        <td>{{ row.submissionStartDate }}</td>
                        <td class="challenges-submitted--action-cell">
                          <div class="challenges-submitted--action-wrap" (click)="$event.stopPropagation()">
                            <button
                              type="button"
                              class="challenges-submitted--action-btn"
                              [class.open]="submittedActionDropdownOpenId === 'submitted-' + row.challengeId"
                              aria-label="Actions"
                              (click)="toggleSubmittedActionDropdown('submitted-' + row.challengeId)"
                            >
                              <span>Action</span>
                            </button>
                            <div class="challenges-submitted--dropdown" *ngIf="submittedActionDropdownOpenId === 'submitted-' + row.challengeId">
                              <button type="button" class="challenges-submitted--dropdown-link" (click)="onSubmittedSolutionDownload(row)">Solution download</button>
                              <button type="button" class="challenges-submitted--dropdown-link" (click)="onSubmittedResubmission(row.challengeId)">Resubmission</button>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr *ngIf="submittedRows.length === 0">
                        <td colspan="4" class="challenges-submitted--empty">No submitted challenges.</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- In Evaluation table: Action = Solution download -->
              <div class="challenges-new-tab--table-wrapper" *ngIf="!submittedLoading && submittedSubTab === 'in-evaluation'">
                <div class="challenges-new-tab--table-container">
                  <table class="challenges-new-tab--table">
                    <thead>
                      <tr>
                        <th>Challenge Name</th>
                        <th>Solution Name</th>
                        <th>Evaluation End Date</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let row of inEvaluationRows">
                        <td><a [routerLink]="['/challenges', row.challengeId]" class="challenges-submitted--link">{{ row.challengeName }}</a></td>
                        <td>{{ row.solutionName }}</td>
                        <td>{{ row.evaluationEndDate }}</td>
                        <td class="challenges-submitted--action-cell">
                          <div class="challenges-submitted--action-wrap" (click)="$event.stopPropagation()">
                            <button
                              type="button"
                              class="challenges-submitted--action-btn"
                              [class.open]="submittedActionDropdownOpenId === 'eval-' + row.challengeId"
                              aria-label="Actions"
                              (click)="toggleSubmittedActionDropdown('eval-' + row.challengeId)"
                            >
                              <span>Action</span>
                            </button>
                            <div class="challenges-submitted--dropdown" *ngIf="submittedActionDropdownOpenId === 'eval-' + row.challengeId">
                              <button type="button" class="challenges-submitted--dropdown-link" (click)="onSubmittedSolutionDownload(row)">Solution download</button>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr *ngIf="inEvaluationRows.length === 0">
                        <td colspan="4" class="challenges-submitted--empty">No challenges in evaluation.</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- Completed table: Results, Comments, Action -->
              <div class="challenges-new-tab--table-wrapper" *ngIf="!submittedLoading && submittedSubTab === 'completed'">
                <div class="challenges-new-tab--table-container">
                  <table class="challenges-new-tab--table">
                    <thead>
                      <tr>
                        <th>Challenge Name</th>
                        <th>Solution Name</th>
                        <th>Evaluation End Date</th>
                        <th>Results</th>
                        <th>Comments</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let row of completedRows">
                        <td><a [routerLink]="['/challenges', row.challengeId]" class="challenges-submitted--link">{{ row.challengeName }}</a></td>
                        <td>{{ row.solutionName }}</td>
                        <td>{{ row.evaluationEndDate }}</td>
                        <td>{{ row.results }}</td>
                        <td>{{ row.comments }}</td>
                        <td class="challenges-submitted--action-cell">
                          <div class="challenges-submitted--action-wrap" (click)="$event.stopPropagation()">
                            <button
                              type="button"
                              class="challenges-submitted--action-btn"
                              [class.open]="submittedActionDropdownOpenId === 'completed-' + row.challengeId"
                              aria-label="Actions"
                              (click)="toggleSubmittedActionDropdown('completed-' + row.challengeId)"
                            >
                              <span>Action</span>
                            </button>
                            <div class="challenges-submitted--dropdown" *ngIf="submittedActionDropdownOpenId === 'completed-' + row.challengeId">
                              <button type="button" class="challenges-submitted--dropdown-link" (click)="onSubmittedSolutionDownload(row)">Solution download</button>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr *ngIf="completedRows.length === 0">
                        <td colspan="6" class="challenges-submitted--empty">No completed challenges.</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <!-- Bookmarks tab: same card design as Overview / New Challenges -->
            <div *ngIf="activeTab === 'bookmarked' && !bookmarksLoading" class="challenges-bookmarks-tab">
              <div class="challenges-new-tab--controls-row">
                <div class="challenges-new-tab--right-controls">
                  <div class="challenges-new-tab--show-dropdown" (click)="$event.stopPropagation()">
                    <button
                      type="button"
                      class="challenges-new-tab--dropdown-trigger"
                      [class.open]="bookmarksTabShowDropdownOpen"
                      (click)="toggleBookmarksTabShowDropdown()"
                    >
                      <span>Showing: <span class="challenges-new-tab--dropdown-value">{{ itemsPerPage }}</span></span>
                    </button>
                    <div class="challenges-new-tab--dropdown-panel" *ngIf="bookmarksTabShowDropdownOpen">
                      <button
                        *ngFor="let opt of bookmarksTabItemsPerPageOptions"
                        type="button"
                        class="challenges-new-tab--dropdown-option"
                        [class.selected]="itemsPerPage === opt"
                        (click)="onBookmarksTabItemsPerPageChange(opt)"
                      >
                        {{ opt }} results/page
                      </button>
                    </div>
                  </div>
                  <div class="challenges-new-tab--view-toggle">
                    <button
                      type="button"
                      class="challenges-new-tab--view-btn"
                      [class.active]="viewMode === 'grid'"
                      (click)="onViewModeChange('grid')"
                      aria-label="Grid view"
                    >
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                        <rect x="3" y="3" width="7" height="7" stroke="currentColor" stroke-width="2"/>
                        <rect x="14" y="3" width="7" height="7" stroke="currentColor" stroke-width="2"/>
                        <rect x="3" y="14" width="7" height="7" stroke="currentColor" stroke-width="2"/>
                        <rect x="14" y="14" width="7" height="7" stroke="currentColor" stroke-width="2"/>
                      </svg>
                      <span class="challenges-new-tab--view-label">Grid</span>
                    </button>
                    <button
                      type="button"
                      class="challenges-new-tab--view-btn"
                      [class.active]="viewMode === 'list'"
                      (click)="onViewModeChange('list')"
                      aria-label="List view"
                    >
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                        <path d="M8 6H21M8 12H21M8 18H21M3 6H3.01M3 12H3.01M3 18H3.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <span class="challenges-new-tab--view-label">List</span>
                    </button>
                    <button
                      type="button"
                      class="challenges-new-tab--view-btn"
                      [class.active]="viewMode === 'table'"
                      (click)="onViewModeChange('table')"
                      aria-label="Table view"
                    >
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                        <path d="M3 3H21V21H3V3Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M3 9H21M9 3V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <span class="challenges-new-tab--view-label">Table</span>
                    </button>
                  </div>
                </div>
              </div>

              <div class="challenges-new-tab--empty" *ngIf="bookmarkedChallengesCardData.length === 0">
                <p>No bookmarked challenges.</p>
              </div>

              <!-- Grid view -->
              <div class="challenges-new-tab--grid" *ngIf="bookmarkedChallengesCardData.length > 0 && viewMode === 'grid'">
                <app-challenge-card
                  *ngFor="let challenge of bookmarkedChallengesCardData"
                  [data]="challenge"
                  [showDescription]="false"
                  class="challenges-new-tab--card"
                ></app-challenge-card>
              </div>
              <!-- List view -->
              <div class="challenges-new-tab--list" *ngIf="bookmarkedChallengesCardData.length > 0 && viewMode === 'list'">
                <a
                  *ngFor="let c of bookmarkedChallengesCardData"
                  [routerLink]="['/challenges', c.id]"
                  class="challenges-new-tab--list-item"
                >
                  <div class="challenges-new-tab--list-image">
                    <img
                      [src]="c.imageUrl || defaultChallengeImageUrl"
                      [alt]="c.name"
                      [style.object-fit]="getListImageObjectFit(c)"
                      (load)="onListImageLoad(c, $event)"
                    />
                  </div>
                  <div class="challenges-new-tab--list-body">
                    <h3 class="challenges-new-tab--list-title">{{ c.name }}</h3>
                    <p class="challenges-new-tab--list-subtitle" *ngIf="c.provider">{{ c.provider }}</p>
                    <div class="challenges-new-tab--list-dates-row">
                      <span class="challenges-new-tab--list-dates" *ngIf="c.submissionStartsAt || c.submissionEndsAt">
                        <svg class="challenges-new-tab--list-dates-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                          <line x1="16" y1="2" x2="16" y2="6"></line>
                          <line x1="8" y1="2" x2="8" y2="6"></line>
                          <line x1="3" y1="10" x2="21" y2="10"></line>
                        </svg>
                        {{ formatChallengeSubmissionRange(c) }}
                      </span>
                      <span class="challenges-new-tab--list-time-left">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                          <circle cx="12" cy="12" r="10"></circle>
                          <polyline points="12 6 12 12 16 14"></polyline>
                        </svg>
                        {{ getListTimeLeftLabel(c) }}
                      </span>
                    </div>
                    <div class="challenges-new-tab--list-stats">
                      <div class="challenges-new-tab--list-stat" title="Participants">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                          <circle cx="9" cy="7" r="4"></circle>
                          <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                        </svg>
                        <span>{{ c.participants ?? 0 }}</span>
                      </div>
                      <div class="challenges-new-tab--list-stat" title="Submissions">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                          <polyline points="14 2 14 8 20 8"></polyline>
                          <line x1="16" y1="13" x2="8" y2="13"></line>
                          <line x1="16" y1="17" x2="8" y2="17"></line>
                          <polyline points="10 9 9 9 8 9"></polyline>
                        </svg>
                        <span>{{ c.submissions ?? 0 }}</span>
                      </div>
                      <div class="challenges-new-tab--list-stat" title="Prize">
                        <svg *ngIf="c.currency?.toUpperCase() === 'USD'" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                          <line x1="12" y1="1" x2="12" y2="23"></line>
                          <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                        </svg>
                        <span class="challenges-new-tab--list-prize">{{ formatChallengePrize(c) }}</span>
                      </div>
                      <span class="challenges-new-tab--list-arrow">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                          <path d="M5 12h14M12 5l7 7-7 7"/>
                        </svg>
                      </span>
                    </div>
                  </div>
                </a>
              </div>
              <!-- Table view -->
              <div class="challenges-new-tab--table-wrapper" *ngIf="bookmarkedChallengesCardData.length > 0 && viewMode === 'table'">
                <div class="challenges-new-tab--table-container">
                  <table class="challenges-new-tab--table">
                    <thead>
                      <tr>
                        <th>TITLE</th>
                        <th>DESCRIPTION</th>
                        <th>SUBMISSION</th>
                        <th>PRIZE</th>
                        <th>PARTICIPANTS</th>
                        <th>ACTION</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let c of bookmarkedChallengesCardData">
                        <td><div class="challenges-new-tab--table-title">{{ c.name }}</div></td>
                        <td>{{ c.description || c.provider || '—' }}</td>
                        <td>{{ formatChallengeSubmissionRange(c) }}</td>
                        <td>{{ formatChallengePrize(c) }}</td>
                        <td>{{ c.participants ?? 0 }}</td>
                        <td>
                          <button type="button" class="challenges-new-tab--table-action" aria-label="View details" (click)="navigateToDetail(c.id)">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                              <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- Pagination -->
              <div class="challenges-new-tab--pagination" *ngIf="bookmarkedChallengesCardData.length > 0 && totalPages > 1">
                <button
                  type="button"
                  class="challenges-new-tab--pagination-btn"
                  [disabled]="currentPage === 1"
                  (click)="onPageChange(1)"
                  aria-label="First page"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M11 18L5 12L11 6M18 18L12 12L18 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
                <button
                  type="button"
                  class="challenges-new-tab--pagination-btn"
                  [disabled]="currentPage === 1"
                  (click)="onPageChange(currentPage - 1)"
                  aria-label="Previous page"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
                <div class="challenges-new-tab--pagination-numbers">
                  <button
                    *ngFor="let page of getBookmarksTabPageNumbers()"
                    type="button"
                    class="challenges-new-tab--pagination-number"
                    [class.active]="page === currentPage"
                    (click)="onPageChange(page)"
                  >
                    {{ page }}
                  </button>
                </div>
                <button
                  type="button"
                  class="challenges-new-tab--pagination-btn"
                  [disabled]="currentPage === totalPages"
                  (click)="onPageChange(currentPage + 1)"
                  aria-label="Next page"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
                <button
                  type="button"
                  class="challenges-new-tab--pagination-btn"
                  [disabled]="currentPage === totalPages"
                  (click)="onPageChange(totalPages)"
                  aria-label="Last page"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M13 18L19 12L13 6M6 18L12 12L6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
              </div>
            </div>

            <!-- Past Challenges / Under Evaluation: same card design as New Challenges (ChallengeCard) -->
            <div *ngIf="(activeTab === 'past-challenges' || activeTab === 'ongoing-challenges') && !pastChallengesLoading && !underEvaluationLoading" class="challenges-past-under-tab">
              <div class="challenges-new-tab--controls-row">
                <div class="challenges-new-tab--action-buttons">
                  <div class="challenges-new-tab--sort-dropdown" (click)="$event.stopPropagation()">
                    <button
                      type="button"
                      class="challenges-new-tab--sort-trigger"
                      [class.open]="activeTab === 'ongoing-challenges' ? underEvaluationSortDropdownOpen : pastChallengesSortDropdownOpen"
                      (click)="activeTab === 'ongoing-challenges' ? toggleUnderEvaluationSortDropdown() : togglePastChallengesSortDropdown()"
                      aria-label="Sort"
                    >
                      <span class="challenges-new-tab--sort-label">Sort: <span class="challenges-new-tab--sort-value">{{ activeTab === 'ongoing-challenges' ? getUnderEvaluationSelectedSortLabel() : getPastChallengesSelectedSortLabel() }}</span></span>
                      <span class="challenges-new-tab--sort-icon" [class.open]="activeTab === 'ongoing-challenges' ? underEvaluationSortDropdownOpen : pastChallengesSortDropdownOpen">⇅</span>
                    </button>
                    <div class="challenges-new-tab--dropdown-panel challenges-new-tab--sort-panel" *ngIf="(activeTab === 'ongoing-challenges' && underEvaluationSortDropdownOpen) || (activeTab === 'past-challenges' && pastChallengesSortDropdownOpen)">
                      <button
                        *ngFor="let opt of newChallengesTabSortOptions"
                        type="button"
                        class="challenges-new-tab--dropdown-option"
                        [class.selected]="(activeTab === 'ongoing-challenges' ? underEvaluationSortOption : pastChallengesSortOption) === opt.value"
                        (click)="activeTab === 'ongoing-challenges' ? onUnderEvaluationSortOptionSelect(opt.value) : onPastChallengesSortOptionSelect(opt.value)"
                      >
                        <div class="checkbox-checkmark-custom" [class.checked]="(activeTab === 'ongoing-challenges' ? underEvaluationSortOption : pastChallengesSortOption) === opt.value"></div>
                        <span>{{ opt.label }}</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="challenges-new-tab--controls-right">
                  <div class="challenges-new-tab--show-dropdown" (click)="$event.stopPropagation()">
                    <button
                      type="button"
                      class="challenges-new-tab--dropdown-trigger"
                      [class.open]="pastUnderEvalShowDropdownOpen"
                      (click)="togglePastUnderEvalShowDropdown()"
                    >
                      <span>Showing: <span class="challenges-new-tab--dropdown-value">{{ itemsPerPage }}</span></span>
                    </button>
                    <div class="challenges-new-tab--dropdown-panel" *ngIf="pastUnderEvalShowDropdownOpen">
                      <button
                        *ngFor="let opt of pastUnderEvalItemsPerPageOptions"
                        type="button"
                        class="challenges-new-tab--dropdown-option"
                        [class.selected]="itemsPerPage === opt"
                        (click)="onPastUnderEvalItemsPerPageChange(opt)"
                      >
                        {{ opt }} results/page
                      </button>
                    </div>
                  </div>
                  <div class="challenges-new-tab--view-toggle">
                    <button
                      type="button"
                      class="challenges-new-tab--view-btn"
                      [class.active]="viewMode === 'grid'"
                      (click)="onViewModeChange('grid')"
                      aria-label="Grid view"
                    >
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                        <rect x="3" y="3" width="7" height="7" stroke="currentColor" stroke-width="2"/>
                        <rect x="14" y="3" width="7" height="7" stroke="currentColor" stroke-width="2"/>
                        <rect x="3" y="14" width="7" height="7" stroke="currentColor" stroke-width="2"/>
                        <rect x="14" y="14" width="7" height="7" stroke="currentColor" stroke-width="2"/>
                      </svg>
                      <span class="challenges-new-tab--view-label">Grid</span>
                    </button>
                    <button
                      type="button"
                      class="challenges-new-tab--view-btn"
                      [class.active]="viewMode === 'list'"
                      (click)="onViewModeChange('list')"
                      aria-label="List view"
                    >
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                        <path d="M8 6H21M8 12H21M8 18H21M3 6H3.01M3 12H3.01M3 18H3.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <span class="challenges-new-tab--view-label">List</span>
                    </button>
                    <button
                      type="button"
                      class="challenges-new-tab--view-btn"
                      [class.active]="viewMode === 'table'"
                      (click)="onViewModeChange('table')"
                      aria-label="Table view"
                    >
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                        <path d="M3 3H21V21H3V3Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M3 9H21M9 3V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <span class="challenges-new-tab--view-label">Table</span>
                    </button>
                  </div>
                </div>
              </div>

              <div class="challenges-new-tab--empty" *ngIf="pastOrUnderEvaluationCardData.length === 0">
                <p>{{ activeTab === 'past-challenges' ? 'No past challenges.' : 'No challenges under evaluation.' }}</p>
              </div>

              <!-- Grid view -->
              <div class="challenges-new-tab--grid" *ngIf="pastOrUnderEvaluationCardData.length > 0 && viewMode === 'grid'">
                <app-challenge-card
                  *ngFor="let challenge of pastOrUnderEvaluationCardData"
                  [data]="challenge"
                  [showDescription]="false"
                  class="challenges-new-tab--card"
                ></app-challenge-card>
              </div>
              <!-- List view -->
              <div class="challenges-new-tab--list" *ngIf="pastOrUnderEvaluationCardData.length > 0 && viewMode === 'list'">
                <a
                  *ngFor="let c of pastOrUnderEvaluationCardData"
                  [routerLink]="['/challenges', c.id]"
                  class="challenges-new-tab--list-item"
                >
                  <div class="challenges-new-tab--list-image">
                    <img
                      [src]="c.imageUrl || defaultChallengeImageUrl"
                      [alt]="c.name"
                      [style.object-fit]="getListImageObjectFit(c)"
                      (load)="onListImageLoad(c, $event)"
                    />
                  </div>
                  <div class="challenges-new-tab--list-body">
                    <h3 class="challenges-new-tab--list-title">{{ c.name }}</h3>
                    <p class="challenges-new-tab--list-subtitle" *ngIf="c.provider">{{ c.provider }}</p>
                    <div class="challenges-new-tab--list-dates-row">
                      <span class="challenges-new-tab--list-dates" *ngIf="c.submissionStartsAt || c.submissionEndsAt">
                        <svg class="challenges-new-tab--list-dates-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                          <line x1="16" y1="2" x2="16" y2="6"></line>
                          <line x1="8" y1="2" x2="8" y2="6"></line>
                          <line x1="3" y1="10" x2="21" y2="10"></line>
                        </svg>
                        {{ formatChallengeSubmissionRange(c) }}
                      </span>
                      <span class="challenges-new-tab--list-time-left">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                          <circle cx="12" cy="12" r="10"></circle>
                          <polyline points="12 6 12 12 16 14"></polyline>
                        </svg>
                        {{ getListTimeLeftLabel(c) }}
                      </span>
                    </div>
                    <div class="challenges-new-tab--list-stats">
                      <div class="challenges-new-tab--list-stat" title="Participants">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                          <circle cx="9" cy="7" r="4"></circle>
                          <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                        </svg>
                        <span>{{ c.participants ?? 0 }}</span>
                      </div>
                      <div class="challenges-new-tab--list-stat" title="Submissions">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                          <polyline points="14 2 14 8 20 8"></polyline>
                          <line x1="16" y1="13" x2="8" y2="13"></line>
                          <line x1="16" y1="17" x2="8" y2="17"></line>
                          <polyline points="10 9 9 9 8 9"></polyline>
                        </svg>
                        <span>{{ c.submissions ?? 0 }}</span>
                      </div>
                      <div class="challenges-new-tab--list-stat" title="Prize">
                        <svg *ngIf="c.currency?.toUpperCase() === 'USD'" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                          <line x1="12" y1="1" x2="12" y2="23"></line>
                          <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                        </svg>
                        <span class="challenges-new-tab--list-prize">{{ formatChallengePrize(c) }}</span>
                      </div>
                      <span class="challenges-new-tab--list-arrow">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                          <path d="M5 12h14M12 5l7 7-7 7"/>
                        </svg>
                      </span>
                    </div>
                  </div>
                </a>
              </div>
              <!-- Table view -->
              <div class="challenges-new-tab--table-wrapper" *ngIf="pastOrUnderEvaluationCardData.length > 0 && viewMode === 'table'">
                <div class="challenges-new-tab--table-container">
                  <table class="challenges-new-tab--table">
                    <thead>
                      <tr>
                        <th>TITLE</th>
                        <th>DESCRIPTION</th>
                        <th>SUBMISSION</th>
                        <th>PRIZE</th>
                        <th>PARTICIPANTS</th>
                        <th>ACTION</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let c of pastOrUnderEvaluationCardData">
                        <td><div class="challenges-new-tab--table-title">{{ c.name }}</div></td>
                        <td>{{ c.description || c.provider || '—' }}</td>
                        <td>{{ formatChallengeSubmissionRange(c) }}</td>
                        <td>{{ formatChallengePrize(c) }}</td>
                        <td>{{ c.participants ?? 0 }}</td>
                        <td>
                          <button type="button" class="challenges-new-tab--table-action" aria-label="View details" (click)="navigateToDetail(c.id)">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                              <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- Pagination -->
              <div class="challenges-new-tab--pagination" *ngIf="pastOrUnderEvaluationCardData.length > 0 && totalPages > 1">
                <button
                  type="button"
                  class="challenges-new-tab--pagination-btn"
                  [disabled]="currentPage === 1"
                  (click)="onPageChange(1)"
                  aria-label="First page"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M11 18L5 12L11 6M18 18L12 12L18 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
                <button
                  type="button"
                  class="challenges-new-tab--pagination-btn"
                  [disabled]="currentPage === 1"
                  (click)="onPageChange(currentPage - 1)"
                  aria-label="Previous page"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
                <div class="challenges-new-tab--pagination-numbers">
                  <button
                    *ngFor="let page of getPastUnderEvalPageNumbers()"
                    type="button"
                    class="challenges-new-tab--pagination-number"
                    [class.active]="page === currentPage"
                    (click)="onPageChange(page)"
                  >
                    {{ page }}
                  </button>
                </div>
                <button
                  type="button"
                  class="challenges-new-tab--pagination-btn"
                  [disabled]="currentPage === totalPages"
                  (click)="onPageChange(currentPage + 1)"
                  aria-label="Next page"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
                <button
                  type="button"
                  class="challenges-new-tab--pagination-btn"
                  [disabled]="currentPage === totalPages"
                  (click)="onPageChange(totalPages)"
                  aria-label="Last page"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M13 18L19 12L13 6M6 18L12 12L6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  </div>

  <!-- Login modal when user clicks Bookmarks or Challenges Submitted in sidebar but is not logged in -->
  <app-login-modal
    *ngIf="showLoginModal"
    [visible]="showLoginModal"
    (visibleChange)="showLoginModal = $event"
  ></app-login-modal>

  <app-footer></app-footer>
</div>

